var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sort",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.952,
    height: 16.952,
    viewBox: "0 0 16.952 16.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface",
    transform: "translate(8.476 0) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22721",
    "data-name": "Group 22721",
    transform: "translate(5.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22720",
    "data-name": "Group 22720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60588",
    "data-name": "Path 60588",
    d: "M2.208,1.293H5.335V0H0V5.335H1.293V2.208l4.43,4.43.914-.914Z",
    fill: "#0092ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22727",
    "data-name": "Group 22727",
    transform: "translate(0 5.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22726",
    "data-name": "Group 22726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60591",
    "data-name": "Path 60591",
    d: "M5.344,1.3V4.43L.914,0,0,.914l4.43,4.43H1.3V6.637H6.637V1.3Z",
    fill: "#0092ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.f5653b21fe88878279e20c0b58581b6e.svg";
export { ForwardRef as ReactComponent };